import axios from 'axios';
import * as types from './types';
import apiUrls from '@/new-constants/apiUrls';

// Número del último pedido de fetchReservations (ver ahí).
let ultimoPedido = 0;

export default {

    async fetchReservations({ commit, state, dispatch }, { page, perPage, user, type, status, search, desglose, modelo, pago, intake, desde, hasta }) {
        let url = `${apiUrls.reservations}?page=${page}&perPage=${perPage}&user=${user}&type=${type}`;
        if (status) url += `&status=${status}`;
        // El buscador va al server: filtra sobre todas las reservas, no sobre la
        // página que el panel tiene a la vista.
        if (search) url += `&search=${encodeURIComponent(search)}`;
        // Panel admin nuevo: reparto del cobro por fila + filtros por modelo y pago.
        if (desglose) url += '&desglose=1';
        if (modelo) url += `&modelo=${encodeURIComponent(modelo)}`;
        if (pago) url += `&pago=${encodeURIComponent(pago)}`;
        // Con / sin intake y fecha de reserva (YYYY-MM-DD).
        if (intake) url += `&intake=${encodeURIComponent(intake)}`;
        if (desde) url += `&desde=${encodeURIComponent(desde)}`;
        if (hasta) url += `&hasta=${encodeURIComponent(hasta)}`;

        // Si el admin cambia dos filtros seguidos, la respuesta vieja puede
        // llegar después de la nueva: solo se guarda la del último pedido.
        const pedido = ++ultimoPedido;
        const response = await axios.get(url);
        if (pedido !== ultimoPedido) return;
        const reservations = response.data;

        dispatch('setReservations', reservations);
    },

    setReservations({ commit }, reservations) {
        commit(types.SET_RESERVATIONS, reservations);
    },

    async setReservationAsPaid({ commit, dispatch }, reservation) {

        const url = `${apiUrls.setReservationAsPaid}`;
        const data = { id_reserva: reservation.idreserva };

        try {
            const response = await axios.post(url, data);

            if (response.status !== 200) {
                console.error('Hubo un error al marcar la reserva como pagada');
            }
            
            return response.data;

        } catch (error) {
            console.error('Hubo un error al comunicarse con el servidor', error);
        }
    },
    
    async setReservationAsCanceled({ commit, dispatch }, reservation) {

        const url = `${apiUrls.reservations}/${reservation.idreserva}`;
        const data = {status: 'canceled'};

        try {
            const response = await axios.put(url, data);

            if (response.status !== 200) {
                console.error('Hubo un error al cancelar la reserva');
            }
            
            return response.data;

        } catch (error) {
            console.error('Hubo un error al comunicarse con el servidor', error);
        }
    },

    async paySecurityDeposit({ commit, dispatch }, reservation) {
        const url = apiUrls.securityDeposit(reservation.idreserva);

        try {
            const response = await axios.post(url);

            if (response.status !== 200) {
                console.error('Hubo un error al marcar la garantía como pagada');
            }

            return response.data;

        } catch (error) {
            console.error('Hubo un error al comunicarse con el servidor', error);
        }
    }
    
};
